import { useContext, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import axios from '../../api/axios';
import AuthContext from '../../api/AuthProvider';

const Header = () => {
    const { user, logoutUser } = useContext(AuthContext);
    const [searchResponse, setSearchResponse] = useState([]);
    const [searchPayload, setSearchPayload] = useState('');
    const [searchToggle, setSearchToggle] = useState(false);
    const dropdownFocus = useRef(null);

    const postSearch = async () => {
        try {
            const requestBody = {
                content: searchPayload,
            };
            let response = await axios.post(
                '/api/profile/search/',
                JSON.stringify(requestBody),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }
            );
            if (response.status === 200) {
                // save response
                setSearchResponse(
                    response.data.map((searchResponse) => searchResponse)
                );
                setSearchToggle(true);
                dropdownFocus.current.focus();
                //refreshes page upon posting
                // window.location.reload(false);
            } else {
                alert('Error');
            }
        } catch (err) {}
    };

    const handleSearchChange = (e) => {
        setSearchPayload(e.target.value);
    };

    const handleSearchBlur = (e) => {
        const currentTarget = e.currentTarget;
        requestAnimationFrame(() => {
            //does not run blur logic if link in dropdown is clicked
            if (!currentTarget.contains(document.activeElement)) {
                setSearchToggle(!searchToggle);
                setSearchPayload('');
            }
        });
    };

    return (
        <header className="header">
            <div className="header-content">
                <h2 className="mb-0 lg-view">Social Investing</h2>
                <h2 className="mb-0 sm-view">Finspace</h2>
                <div className="header-content-search">
                    <div className="header-content-search-input">
                        <input
                            type="text"
                            className="form-control form-control-md h-75"
                            placeholder="Search"
                            value={searchPayload}
                            onChange={handleSearchChange}
                        />
                        <button
                            className="btn icon-button header-search-button"
                            type="button"
                            aria-label="Search users"
                            onClick={postSearch}
                        >
                            <i className="bi bi-search bi-icon-md" />
                        </button>
                        {searchToggle && (
                            <div
                                className="header-dropdown-results"
                                tabIndex={0}
                                ref={dropdownFocus}
                                onBlur={handleSearchBlur}
                            >
                                {searchResponse.map((searchResponse) => (
                                    <ul>
                                        <Link
                                            className="header-dropdown-item"
                                            reloadDocument
                                            to={
                                                '/profile/' +
                                                searchResponse.username
                                            }
                                        >
                                            <p className="header-dropdown-results-text">
                                                {searchResponse.first_name}{' '}
                                                {searchResponse.last_name}
                                            </p>
                                        </Link>
                                    </ul>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="header-content-right">
                    <div className="dropdown">
                        <button
                            className="btn icon-button header-button"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <i className="bi-person-badge bi-icon-md" />
                        </button>
                        <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                        >
                            <li>
                                <Link
                                    className="dropdown-item"
                                    reloadDocument
                                    to={`/profile/${user.username}`}
                                >
                                    {user.firstname} {user.lastname}
                                </Link>
                            </li>
                            <li>
                                <p
                                    className="dropdown-item"
                                    onClick={logoutUser}
                                >
                                    Log out
                                </p>
                            </li>
                        </ul>
                    </div>
                    <button className="btn icon-button header-button">
                        <i className="bi-bell bi-icon-md" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
